// extracted by mini-css-extract-plugin
export default {"buttonContainer":"lqUu6","alignToEdge":"d61mD","buttonIcon":"_4QYNS","buttonCaption":"zQm5H","buttonSpacer":"NzwQw"};